import {
  MAIL_STORAGE_INBOX_ARCHIVE_DONE_COVERAGE_MIN,
  MAIL_STORAGE_INBOX_ARCHIVE_DONE_MISSING_MAX,
} from "@/lib/constants/mailStorage";

export function inboxArchiveCoveragePercent(target: number, missing: number): number {
  if (target <= 0) return 0;
  const covered = Math.max(0, target - missing);
  return Math.min(100, Math.round((covered / target) * 100));
}

/** INBOX archivage « assez bon » — ex. 199/200, worker inactif → masquer la barre Réception. */
export function isInboxArchiveEffectivelyDone(options: {
  inboxMissing: number;
  inboxTarget: number;
  archiveInProgress: boolean;
  archiveError: string | null;
  inboxBootstrapDone?: boolean;
}): boolean {
  const { inboxMissing, inboxTarget, archiveInProgress, archiveError, inboxBootstrapDone } = options;
  if (archiveInProgress || archiveError != null) return false;
  if (inboxBootstrapDone && inboxMissing <= 0) return true;
  if (inboxMissing <= 0) return true;
  const coverage = inboxArchiveCoveragePercent(inboxTarget, inboxMissing);
  return (
    inboxMissing <= MAIL_STORAGE_INBOX_ARCHIVE_DONE_MISSING_MAX &&
    coverage >= MAIL_STORAGE_INBOX_ARCHIVE_DONE_COVERAGE_MIN
  );
}
